var render = function render(){var _vm=this,_c=_vm._self._c;return _c('usage-comparisons-table',{attrs:{"items":_vm.items,"loading":_vm.loading,"currency":_vm.currency,"type":_vm.type},scopedSlots:_vm._u([{key:"itemName",fn:function({ item }){return [_c('router-link',{attrs:{"to":`${_vm.routePrefix}/products/${item.productId}`}},[_vm._v(" "+_vm._s(item.productName)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }